import type { IllustrationAsset } from "../types";

const rawAssets = [
  ["wash", "Laver", "Préparer", ["rincer", "nettoyer", "eau"], "💧"],
  ["peel", "Éplucher", "Préparer", ["peler", "économe"], "🥕"],
  ["cut", "Découper", "Préparer", ["couper", "trancher", "hacher"], "🔪"],
  ["grate", "Râper", "Préparer", ["râpe", "fromage", "légume"], "🧀"],
  ["pour", "Verser", "Mesurer", ["transvaser", "liquide"], "🫗"],
  ["measure", "Doser", "Mesurer", ["peser", "mesurer", "balance"], "⚖️"],
  ["mix", "Mélanger", "Assembler", ["remuer", "incorporer"], "🥣"],
  ["whisk", "Fouetter", "Assembler", ["battre", "émulsionner"], "🌀"],
  ["knead", "Pétrir", "Assembler", ["pâte", "malaxer"], "🤲"],
  ["shape", "Façonner", "Assembler", ["former", "bouler", "pâte", "pain"], "🥖"],
  ["roll", "Étaler", "Préparer", ["rouleau", "abaisser", "pâte"], "🫓"],
  ["brush", "Badigeonner", "Préparer", ["pinceau", "dorer", "œuf", "beurre"], "🖌️"],
  ["blend", "Mixer", "Assembler", ["mixeur", "blender", "réduire", "purée"], "⚙️"],
  ["drain", "Égoutter", "Préparer", ["passoire", "eau", "filtrer"], "🫗"],
  ["melt", "Faire fondre", "Cuire", ["beurre", "chocolat", "casserole"], "🍫"],
  ["rest", "Laisser reposer", "Attendre", ["repos", "lever", "mariner"], "⏳"],
  ["set-aside", "Mettre de côté", "Attendre", ["réserver", "pause", "patienter", "poser"], "⏸️"],
  ["cool", "Laisser refroidir", "Attendre", ["refroidir", "tiédir", "grille"], "❄️"],
  ["heat", "Faire chauffer", "Cuire", ["chauffer", "réchauffer", "température", "feu doux"], "🌡️"],
  ["boil", "Faire bouillir", "Cuire", ["ébullition", "casserole", "eau"], "♨️"],
  ["deep-fry", "Faire frire", "Cuire", ["friture", "huile", "beignet", "frite"], "🫧"],
  ["pan-fry", "Cuire à la poêle", "Cuire", ["poêle", "saisir", "griller"], "🍳"],
  ["saute", "Faire revenir", "Cuire", ["dorer", "oignon", "huile"], "🧅"],
  ["bake", "Cuire au four", "Cuire", ["four", "enfourner", "rôtir"], "🔥"],
  ["season", "Ajouter des épices", "Assaisonner", ["épices", "sel", "poivre"], "🧂"],
  ["plate", "Dresser", "Finaliser", ["présenter", "assiette", "garnir"], "🍽️"],
  ["serve", "Servir", "Finaliser", ["déguster", "table"], "😋"],
] as const;

const illustratedActionUrls: Partial<Record<(typeof rawAssets)[number][0], string>> = {
  wash: "/illustrations/wash-lumi.png",
  peel: "/illustrations/peel-lumi.png",
  cut: "/illustrations/cut-lumi.png",
  grate: "/illustrations/grate-lumi.png",
  pour: "/illustrations/pour-lumi.png",
  measure: "/illustrations/measure-lumi.png",
  mix: "/illustrations/mix-lumi.png",
  whisk: "/illustrations/whisk-lumi.png",
  knead: "/illustrations/knead-lumi.png",
  shape: "/illustrations/shape-lumi.png",
  roll: "/illustrations/roll-lumi.png",
  brush: "/illustrations/brush-lumi.png",
  blend: "/illustrations/blend-lumi.png",
  drain: "/illustrations/drain-lumi.png",
  melt: "/illustrations/melt-lumi.png",
  rest: "/illustrations/rest-lumi.png",
  "set-aside": "/illustrations/set-aside-lumi.png",
  cool: "/illustrations/cool-lumi.png",
  heat: "/illustrations/heat-lumi.png",
  boil: "/illustrations/boil-lumi.png",
  "deep-fry": "/illustrations/deep-fry-lumi.png",
  "pan-fry": "/illustrations/pan-fry-lumi.png",
  saute: "/illustrations/saute-lumi.png",
  bake: "/illustrations/bake-lumi.png",
  season: "/illustrations/season-lumi.png",
  plate: "/illustrations/plate-lumi.png",
  serve: "/illustrations/serve-lumi.png",
};

export const illustrationAssets: IllustrationAsset[] = rawAssets.map(
  ([id, name, category, keywords, symbol]) => ({
    id,
    name,
    category,
    keywords: [...keywords],
    url: illustratedActionUrls[id] ?? `/illustrations/${id}.svg`,
    animatedUrl: illustratedActionUrls[id] ? `/illustrations/animated/${id}.webp` : undefined,
    alt: `Illustration de l’action : ${name.toLocaleLowerCase("fr")}`,
    symbol,
  }),
);

export const illustrationCategories = [...new Set(illustrationAssets.map((asset) => asset.category))];

export function findIllustration(id?: string) {
  return illustrationAssets.find((asset) => asset.id === id);
}

export function filterIllustrations(query: string, category: string) {
  const normalized = query.trim().toLocaleLowerCase("fr");
  return illustrationAssets.filter((asset) => {
    const matchesCategory = category === "Toutes" || asset.category === category;
    const haystack = [asset.name, asset.category, ...asset.keywords].join(" ").toLocaleLowerCase("fr");
    return matchesCategory && (!normalized || haystack.includes(normalized));
  });
}
